import { api } from './api-client';
import { ApiResponse, AuthSession, AuthUser } from '../types/api';

export interface LoginInput {
  email: string;
  password: string;
}

export interface RefreshTokens {
  accessToken: string;
  refreshToken: string;
}

export async function login(input: LoginInput): Promise<AuthSession> {
  const response = await api.post<ApiResponse<AuthSession>>('/auth/login', input);
  return response.data.data;
}

export async function getCurrentUser(): Promise<AuthUser> {
  const response = await api.get<ApiResponse<AuthUser>>('/auth/me');
  return response.data.data;
}

export async function logout(refreshToken: string): Promise<void> {
  await api.post('/auth/logout', { refreshToken });
}
